import { BadgeCheck, BookOpen, Circle, Clock3 } from "lucide-react";
import type { SkillStatus } from "@peer-start/platform-contracts";
import type { StatusBadgeProps } from "../types/components.js";

const statusStyles: Record<SkillStatus, string> = {
  unassessed: "bg-muted text-muted-foreground",
  to_train: "bg-destructive text-destructive-foreground",
  on_checklist: "bg-warning text-warning-foreground",
  established: "bg-success text-success-foreground",
};

const statusIcons = {
  unassessed: Circle,
  to_train: BookOpen,
  on_checklist: Clock3,
  established: BadgeCheck,
} as const;

export function StatusBadge({ status, label, compact = false }: StatusBadgeProps) {
  const Icon = statusIcons[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${statusStyles[status]} ${compact ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm"}`}
      data-status={status}
    >
      <Icon aria-hidden="true" className={compact ? "size-3.5" : "size-4"} />
      {label}
    </span>
  );
}
